/**
 * Kişi eşleme kuralları — saf fonksiyonlar (`npm run test:directory`).
 *
 * E-posta her zaman önce gelir; e-postalı ve e-postasız kayıtlar birbirine
 * karışmaz:
 *  - E-postası bilinen katılımcı (takvimden) yalnızca e-postayla eşleşir;
 *    aynı adlı e-postasız kaydı sahiplenmez.
 *  - E-postası bilinmeyen katılımcı (linkten katılan, botun gördüğü ad)
 *    yalnızca e-postasız ve adı BİREBİR aynı kayda yazılır — büyük/küçük
 *    harf dahil ("Ahmet Yılmaz" ≠ "ahmet yılmaz" ≠ "Ahmet").
 * Tek esneklik boşluklar: baş/son boşluk atılır, iç boşluklar teke iner.
 */

/** Görünen ad: baş/son boşluk atılır, iç boşluklar teke indirilir. */
export function normalizePersonName(name: string | undefined | null): string {
  return (name ?? '').normalize('NFC').replace(/\s+/g, ' ').trim();
}

/** İki ad aynı kişiyi mi gösteriyor — birebir (harf duyarlı) karşılaştırma. */
export function samePersonName(a: string | undefined | null, b: string | undefined | null): boolean {
  const left = normalizePersonName(a);
  return left !== '' && left === normalizePersonName(b);
}

export interface NameCandidate {
  id: string;
  name: string;
  email: string | null;
}

/**
 * Aday kayıtlar (eskiden yeniye) arasından isimle bağlanacak kişiyi seçer.
 * E-postalı katılımcı isimle hiçbir kayda bağlanmaz; e-postasız katılımcı
 * adı birebir aynı olan en eski e-postasız kayda bağlanır.
 */
export function pickNameMatch<T extends NameCandidate>(
  candidates: T[],
  name: string,
  email: string | null
): T | null {
  if (email) return null;
  return candidates.find((c) => !c.email && samePersonName(c.name, name)) ?? null;
}
